import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
   selector: 'samweb-tooltip-container',
   templateUrl: './tooltip-container.component.html',
   styleUrls: ['./tooltip-container.component.scss'],
})
export class TooltipContainerComponent {
   @Input()
   public position: 'bottom' | 'top' | 'left' | 'right' | 'center' = 'top';

   public isTooltipOpen$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
   constructor() {}
}
